// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { EnvironmentModel } from 'src/app/_interfaces/environment-model';
import { environmentDefault } from './defaults';

export const environment: EnvironmentModel = {
  ...environmentDefault,
  production: false,
};
